const CANONICAL_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function canonicalRaffleEventId(value: string | null | undefined): string | null {
  const candidate = String(value || '').trim();
  return CANONICAL_UUID.test(candidate) ? candidate : null;
}

export function raffleResultPath(eventId: string): string {
  return `/api/raffle/events/${encodeURIComponent(eventId)}`;
}
